import React, { useContext, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { RootStoreContext } from './global/storeContext';
import { Loader } from './components/loader/loader';
import routes, { IRoute, paths } from './routes';
import { Alert, AlertColor, Snackbar } from '@mui/material';

const AuthGate: React.FC<{ children?: React.ReactNode }> = observer(({ children }) => {
    const { userStore, uiStore } = useContext(RootStoreContext);

    useEffect(() => {
        if (!userStore.isAuthenticated) {
            uiStore.goTo(paths.login, window.location.href);
        }
    }, [userStore, userStore.userId, uiStore]);

    return <>{children}</>;
});

const NoAuthGate: React.FC<{ children?: React.ReactNode }> = observer(({ children }) => {
    const { userStore, uiStore } = useContext(RootStoreContext);
    useEffect(() => {
        if (userStore.isAuthenticated) {
            uiStore.goTo(paths.home);
        }
    }, [userStore, userStore.userId, uiStore]);

    return <>{children}</>;
});

const App: React.FC = observer(() => {
    const { uiStore } = useContext(RootStoreContext);

    const alertMsg = () => {
        const msg = uiStore.toastrMsg?.message ?? '';
        return <div dangerouslySetInnerHTML={{ __html: msg }} />;
    };

    return (
        <>
            <div className='App'>
                <Loader loading={uiStore.loading} />

                <Routes>
                    {routes.map((prop: IRoute, key) => {
                        if (prop.authGuard) {
                            return (
                                // <Route path={prop.path} key={key} element={<prop.component />}>
                                <Route
                                    path={prop.path}
                                    key={key}
                                    element={
                                        <AuthGate>
                                            <prop.component />
                                        </AuthGate>
                                    }
                                ></Route>
                            );
                        } else if (prop.noAuthGuard) {
                            return (
                                <Route
                                    path={prop.path}
                                    key={key}
                                    element={
                                        <NoAuthGate>
                                            <prop.component />
                                        </NoAuthGate>
                                    }
                                ></Route>
                            );
                        } else {
                            return (
                                <Route
                                    path={prop.path}
                                    element={<prop.component />}
                                    key={key}
                                ></Route>
                            );
                        }
                    })}
                </Routes>
                <Snackbar
                    open={uiStore.toastrOpen}
                    autoHideDuration={6000}
                    onClose={uiStore.closeToastr}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                    <Alert
                        elevation={6}
                        variant='filled'
                        onClose={uiStore.closeToastr}
                        severity={(uiStore.toastrMsg?.severity as AlertColor) ?? 'info'}
                    >
                        {alertMsg()}
                    </Alert>
                </Snackbar>
            </div>
        </>
    );
});

export default App;
